var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{attrs:{"fluid":""}},[_c('Header'),(_vm.permalink !== null)?_c('section',{staticClass:"mt-3"},[_c('test-attempt-form',{attrs:{"testPermalink":_vm.permalink},on:{"success":() => _vm.$router.push('/tests')}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }